<template>
    <b-modal id="winstore_manager_modal">
        <template slot="modal-title">Manage Winstore connection</template>
        <b-form ref="winstore_manager_modal_form" v-if="project_data.connections.indexOf('Winstore') === -1">
            <b-form-group label="The Api user name">
                <b-form-input
                        id="api_user"
                        :state="validateApiUser"
                        v-model="winstore_credentials.api_user"
                        required/>
                <b-form-invalid-feedback :state="validateApiUser">
                    Api user is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="The api key">
                <b-form-input
                        id="api_key"
                        :state="validateApiKey"
                        v-model="winstore_credentials.api_key"
                        required/>
                <b-form-invalid-feedback :state="validateApiKey">
                    Api key is required.
                </b-form-invalid-feedback>
            </b-form-group>
            <hr/>
            <b-button block
                      variant="primary"
                      :disabled="authorizing"
                      @click="authorize">
                Authorize
            </b-button>
        </b-form>
        <div v-if="project_data.connections.indexOf('Winstore') >= 0">
            <b-button block
                      variant="danger"
                      :disabled="clearing_credentials"
                      @click="clearCredentials">
                Clear credentials
            </b-button>
        </div>
    </b-modal>
</template>
<script>
    import winstoreConnectionService from '../../../services/WinstoreConnectionService';

    export default {
        props: {
            project_data: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                winstore_credentials: {
                    api_user: '',
                    api_key: '',
                },
                authorizing: false,
                clearing_credentials: false
            }
        },
        methods: {
            checkFields() {
                if (this.winstore_credentials.api_user.length <= 0) return false;
                if (this.winstore_credentials.api_key.length <= 0) return false;
                return true;
            },
            authorize(modal) {
                if (this.$refs.winstore_manager_modal_form.checkValidity() && this.checkFields()) {
                    let self = this;
                    const body = Object.assign(
                        {project_id: this.project_data.project_id},
                        this.winstore_credentials
                    );
                    this.authorizing = true;

                    winstoreConnectionService.authorize(body).then(res => {
                        if (res.data.success) {
                            self.winstore_credentials.api_user = '';
                            self.winstore_credentials.api_key = '';
                            self.$emit('winstore-authorization-complete', this.project_data.project_id);
                        }
                        this.authorizing = false;
                    });
                } else {
                    modal.preventDefault();
                }
            },
            clearCredentials() {
                this.clearing_credentials = true;

                winstoreConnectionService.clearCredentials(this.project_data.project_id).then(res => {
                    if (res.data.success) {
                        this.project_data.connections = this.project_data.connections.filter(p => p !== 'Winstore');
                    }

                    this.clearing_credentials = false;
                });
            }
        },
        computed: {
            validateApiUser() {
                return this.winstore_credentials.api_user.length > 0;
            },
            validateApiKey() {
                return this.winstore_credentials.api_key.length > 0;
            }
        }
    }
</script>
